/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Payment_Validation_Transaction_Code_LengthInputs */

const en_case_payment_validation_transaction_code_length = /** @type {(inputs: Case_Payment_Validation_Transaction_Code_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The transaction code must have at most 200 characters.`)
};

const pt_br2_case_payment_validation_transaction_code_length = /** @type {(inputs: Case_Payment_Validation_Transaction_Code_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O código da transação deve ter no máximo 200 caracteres.`)
};

/**
* | output |
* | --- |
* | "The transaction code must have at most 200 characters." |
*
* @param {Case_Payment_Validation_Transaction_Code_LengthInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_validation_transaction_code_length = /** @type {((inputs?: Case_Payment_Validation_Transaction_Code_LengthInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Validation_Transaction_Code_LengthInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_validation_transaction_code_length(inputs)
	return pt_br2_case_payment_validation_transaction_code_length(inputs)
});